class OylinMaterialTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.abortController = null;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index, true), { signal });
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
    });

    const selectedIndex = Math.max(
      0,
      this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'),
    );
    this.activate(selectedIndex, false);
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  activate(index, moveFocus) {
    if (!this.tabs[index]) return;

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });

    if (moveFocus) this.tabs[index].focus({ preventScroll: true });
  }

  onKeydown(event, index) {
    let nextIndex = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    }

    if (nextIndex === null) return;
    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!customElements.get('oylin-material-tabs')) {
  customElements.define('oylin-material-tabs', OylinMaterialTabs);
}